<template>
	<div>
		<div v-show="isChatingId" class="topButton">
			<div class="Name">{{nickname}}</div>
			<div class="closeChat">
				<!-- ,gIndex,true -->
				<el-button size="mini" type="primary" @click="deleteChating()">结束会话</el-button>
			</div>
		</div>
		<div v-if="kefuAccessStatus" class="kefu-access-status">
			<div class="kefu-access-status-left">
				<i class="el-icon-warning"></i>
				{{kefuAccessTip}}
			</div>
			<i class="el-icon-close" @click="closeKefuAccessStatus"></i>
		</div>
		<div v-show="!isChatingId" class="shopro-chat-container scrollbar-containering shopro-chat-container-icon">
			<div class="shopro-chat-container-tip">
				暂时没有会话哦!
			</div>
		</div>
		<div v-show="isChatingId" class="shopro-chat-container scrollbar-containering" ref="shoproChatContainerRef">
			<div class="no-more-data" v-if="!message_num">没有更多数据了</div>
			<template v-if="isChatingId">
				<div class="shopro-chat-container-item"
					:class="[specific.sender_identify=='customer_service'?'customer-service':'customer-user',specific.message_type=='system'?'customer-system':'']"
					v-for="(specific,specificindex) in specificChatMessage" :key="specificindex"
					style="flex-direction: column;">
					<template v-if="specific.message_type=='system'">
						<div class="shopro-chat-system">{{specific.message}}</div>
					</template>
					<template v-if="specific.sender_identify=='user' && specific.message_type!='system'">
						<template>
							<div class="specific-createtime"
								v-if="specificindex>0 && specific.createtime-specificChatMessage[specificindex-1].createtime>300">
								<div class="createtime-item">
									{{formatDate(specific.createtime*1000)}}
								</div>
							</div>
							<div class="specific-createtime" v-if="specificindex==0 && specific.createtime">
								<div class="createtime-item">
									{{formatDate(specific.createtime*1000)}}
								</div>
							</div>
						</template>
						<div class="display-flex">
							<div class="shopro-chat-container-item-image">
								<el-image v-if="specific.identify"
									:src="specific.identify.avatar?specific.identify.avatar:'../assets/chat/user-default.png'"
									fit="cover">
									<div slot="error" class="image-slot">
										<i class="el-icon-picture-outline"></i>
									</div>
								</el-image>
							</div>
							<div class="shopro-chat-container-item-message">
								<!--type='text' -->
								<div class="shopro-chat-container-item-message-text"
									v-if="specific.message_type=='text'" v-html="replaceEmjio(specific.message)"> </div>
								<!--type='image' -->
								<div class="shopro-chat-container-item-message-text shopro-chat-image"
									:style="{width:!specific.hidden?'30px':''}" v-if="specific.message_type=='image'">
									<i v-if="!specific.hidden" class="el-icon-loading"></i>
									<el-image ref="imageRef" lazy :src="specific.message" fit="contain"
										@load="getimageload(specificindex)" @error="imagerror(specificindex)">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
										</div>
									</el-image>
								</div>
								<!--type='goods' -->
								<div class="shopro-chat-goods-item" v-if="specific.message_type=='goods'"
									@click="openGoods(specific.message.id)">
									<div class="shopro-chat-goods-image">
										<el-image :src="specific.message.image" fit="contain">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</div>
									<div class="shopro-chat-goods-message">
										<div class="display-flex">
											<div style="margin-right:10px;">{{specific.message.id}}</div>
											<div class="shopro-chat-goods-title ellipsis-item">
												{{specific.message.title}}
											</div>
										</div>
										<div class="shopro-chat-goods-bodys display-flex">
											<div>￥{{specific.message.price}}</div>
										</div>
									</div>
								</div>
								<!--type='order' -->
								<div class="shopro-chat-order-item" v-if="specific.message_type=='order'"
									@click="openOrder(specific.message.id)">
									<div class="shopro-chat-order-title">订单号：{{specific.message.order_sn}}</div>
									<div class="shopro-chat-goods-item">
										<div class="shopro-chat-goods-image">
											<el-image :src="specific.message.image" fit="contain">
												<div slot="error" class="image-slot">
													<i class="el-icon-picture-outline"></i>
												</div>
											</el-image>
										</div>
										<div class="shopro-chat-goods-message">
											<div class="display-flex">
												<div style="margin-right:10px">{{specific.message.id}}</div>
												<div class="shopro-chat-goods-title ellipsis-item">
													{{specific.message.title}}
												</div>
											</div>
											<div class="shopro-chat-goods-bodys display-flex">
												<div>￥{{specific.message.price}}</div>
												<div class="shopro-chat-goods-stock">x{{specific.message.num}}</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
					<template v-if="specific.sender_identify=='customer_service' && specific.message_type!='system'">
						<div class="specific-createtime"
							v-if="specificindex>0 && specific.createtime-specificChatMessage[specificindex-1].createtime>300">
							<div class="createtime-item">
								{{formatDate(specific.createtime*1000)}}
							</div>
						</div>
						<div class="specific-createtime" v-if="specificindex==0 && specific.createtime">
							<div class="createtime-item">
								{{formatDate(specific.createtime*1000)}}
							</div>
						</div>
						<div class="display-flex" style="justify-content: flex-end;">
							<div class="shopro-chat-container-item-message-1">
								<!--type='text' -->
								<div class="shopro-chat-container-item-message-text"
									v-if="specific.message_type=='text'" v-html="replaceEmjio(specific.message)"> </div>
								<!--type='image' -->
								<div class="shopro-chat-container-item-message-text shopro-chat-image"
									:style="{width:!specific.hidden?'30px':''}"
									v-if="specific.message_type=='image' && specific.message">
									<i v-if="!specific.hidden" class="el-icon-loading"></i>
									<el-image ref="imageRef" lazy :src="specific.message" fit="contain"
										@load="getimageload(specificindex)" @error="imagerror(specificindex)">
										<div slot="error" class="image-slot">
											<i class="el-icon-picture-outline"></i>
										</div>
									</el-image>
								</div>
								<div class="shopro-chat-goods-item" v-if="specific.message_type=='goods'"
									@click="openGoods(specific.message.id)">
									<div class="shopro-chat-goods-image">
										<el-image :src="specific.message.image" fit="contain">
											<div slot="error" class="image-slot">
												<i class="el-icon-picture-outline"></i>
											</div>
										</el-image>
									</div>
									<div class="shopro-chat-goods-message">
										<div class="display-flex">
											<div style="margin-right:10px">{{specific.message.id}}</div>
											<div class="shopro-chat-goods-title ellipsis-item">
												{{specific.message.title}}
											</div>
										</div>
										<div class="shopro-chat-goods-bodys display-flex">
											<div>￥{{specific.message.price}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="shopro-chat-container-item-image-1">
								<el-image v-if="specific.identify"
									:src="specific.identify.avatar?specific.identify.avatar:'../assets/chat/default.png'"
									fit="cover">
									<div slot="error" class="image-slot">
										<i class="el-icon-picture-outline"></i>
									</div>
								</el-image>
							</div>
						</div>
					</template>
				</div>
			</template>
		</div>
		<div class="shopro-send-container shopro-nosend-container" v-show="isChatingId && kefuAccessStatusSend">
			暂时无法与之会话
		</div>
		<div class="shopro-send-container" v-show="isChatingId && !kefuAccessStatusSend && isShowInput">
			<div class="shopro-send-tip-container">
				<el-popover placement="top-start" width="222" trigger="hover">
					<div class="scrollbar-containering shopro-chat-emoji-container" style="">
						<div class="shopro-chat-emoji-image" v-for="(emoji ,index) in emoji_list" :key="index"
							@click="selectEmoji(emoji)">
							<!-- {{emoji.file}} -->
							<el-image :src="require('@/assets/emoji/'+emoji.file)" fit="contain">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
						</div>
					</div>
					<img class="shopro-send-tip-item" slot="reference" src="@/assets/chat/expression.png" />
				</el-popover>
				<!-- 常用语 -->
				<!-- <el-popover placement="top-start" width="180" v-model="commonWordsvisible">
					<div>
						<div class="common-words-item" v-if="commonWordsList.length==0">赶紧去配置常用语吧～</div>
						<div class="scrollbar-containering el-popover-common-words" v-if="commonWordsList.length>0">
							<div class="common-words-item ellipsis-item" v-for="(words,wordsIndex) in commonWordsList"
								:key="wordsIndex" @click="selectCommonWords(wordsIndex)">{{words.name}}</div>
						</div>
					</div> -->
				<!-- <img class="shopro-send-tip-item" slot="reference" src="@/assets/chat/commonWords.png" /> -->
				<!-- </el-popover> -->
				<!-- <img class="shopro-send-tip-item" style="margin-top: 4px;" @click="selectGoods()" src="../a/chat/goods.png" /> -->
				<div class="shopro-send-tip-item">
					<label for="inputFile">
						<img class="shopro-send-tip-item" src="@/assets/chat/file.png" />
					</label>
					<input id="inputFile" type="file" @change="addfile" ref="inputFileRef" multiple
						accept="image/png,image/jpeg,image/gif,image/jpg" />
				</div>
			</div>
			<div class="shopro-send-textarea scrollbar-containering">
				<div class="shopro-send-pre" ref="editor" contenteditable="true" data-placeholder="请输入..."
					@keydown="successMessage($event)">
				</div>

			</div>
			<div class="shopro-send-button-container">
				<div class="shopro-send-button" @click="successMessage()">发送</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex';
	import {
		res,
		wsUri
	} from '../config/res.js'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: '',
			},
			isShowInput: {
				type: Boolean,
				default: true,
			},
			// buylist: {
			// 	type: Object,
			// 	default: () => {}
			// },
			chatid: {
				type: [Number, String],
				default: '',
			},
			index: {
				type: [Number, String],
				default: '',
			},
			row: {
				type: Object,
				default: () => {},
			},
			opt: {
				type: Boolean,
				default: true,
			},
			groupIndex: {
				type: [Number, String],
				default: 0,
			},
			page: {
				type: [Number, String],
				default: 1,
			},
			// specificChatMessage: {
			// 	type: Array,
			// 	default: () => [],
			// },
			// isMoreList: {
			// 	type: Boolean,
			// 	default: false,
			// },
			// message_num: {
			// 	type: [Number, String],
			// 	default: 0,
			// },
		},
		data() {
			return {
				passvalue: {
					commonWordsList: res.data.fast_reply,
					token: res.data.token,
					wsUri: wsUri,
					expire_time: res.data.expire_time,
					customer_service_id: res.data.customer_service.id,
					adminData: res.data,
					emoji_list: res.data.emoji
				},
				searchName: '',
				wsUri: 'wss://michata.us.cc/websocket/',
				isClick: false,
				dialogVisible: false,
				lineStatus: '',
				// liaoStatus: 'buyerOnlines',
				openGroupList: [],

				commonWordsvisible: false,
				sendMessage: '',

				// specificChatMessage: [],
				last_id: '',
				per_page: 10,

				emoji_list: [],
				emojivisible: false,

				websocket: null,
				relink: 0,
				max_relink: 0,


				temporaryObj: {}, //临时消息的id
				user_offline: [], //用户下线
				shoproKefuShake: false,
				shoproChatContainerRefScrollTop: 0,

				// message_num: 10,
				adminData: [],
				commonWordsList: [],
				timeInterval: null,
				kefuButtonvisible: false,
				rightShowId: null,
				rightShowPosition: {
					top: 0,
					left: 0
				},
				changeKefu: null,

				changeKefuList: [],
				value: '',
				transferAdminList: '',
				openPing: null,
				errorTipVisible: false,

				// 客服是否介入
				kefuAccessStatus: false,
				kefuAccessStatusSend: false,
				kefuAccessTip: '',
				kefuLinkNum: 0,
				uploading: false,

				nickname: '',
				msgInput: '',
				isMoreLists: false,

			}
		},
		watch: {
			chatid: {
				handler(val) {
					this.selectChating(val, this.index, this.opt, this.row)
				},
				immediate: true
			},
			// chatid(newVal) {
			// 	this.selectChating(newVal, this.index, this.opt, this.row)
			// },
			//滚动类型
			scrollType: {
				handler(val) {
					this.scrollBy(val.type)
				},
				deep: true
			},
			//右侧消息列表
			specificChatMessage: {
				handler(val) {
					this.specificChatMessage = val.length ? val : this.specificChatMessage
					// this.specificChatMessage = val
				},
				immediate: true
			},
			//有无更多列表
			isMoreList: {
				handler(val) {
					this.isMoreLists = val
				},
				immediate: true
			},
			isChatingId: {
				handler(val) {
					this.isChatingId = val
				},
				immediate: true
			},
		},
		computed: {
			...mapState('kefu', ['specificChatMessage', 'scrollType','liaoStatus', 'isMoreList']),
			message_num() {
				return this.specificChatMessage.length
			}
		},
		created() {
			this.adminData = this.passvalue.adminData;
			this.emoji_list = this.passvalue.emoji_list;
			this.commonWordsList = this.passvalue.commonWordsList;
		},
		mounted() {},
		methods: {
			emojiShow() {
				this.emojivisible = true
			},
			formatDate(time) {
				if (!time) return ''

				const date = new Date(time)

				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')

				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')

				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			},
			closerightShowId() {
				this.rightShowId = null;
				this.$forceUpdate();
			},
			show(e, service_id) {
				if (this.groupIndex == 0) {
					this.rightShowId = service_id;
					this.rightShowPosition.top = e.clientY + 'px';
					this.rightShowPosition.left = e.clientX + 'px';
				}
			},
			getimageload(index) {
				this.$set(this.specificChatMessage[index], 'hidden', true)
			},
			imagerror(index) {
				this.$set(this.specificChatMessage[index], 'hidden', true)
			},
			scrollBy(scrollType) {
				switch (scrollType) {
					case 'receipt': { //发送成功
						this.$refs.shoproChatContainerRef.scrollTop = this.$refs.shoproChatContainerRef
							.scrollHeight;
						this.$refs.editor.innerHTML = '';
						break;
					}
					case 'message': { //接收到消息
						this.$forceUpdate();
						//调整滚动条
						this.$nextTick(() => {
							if (this.$refs.shoproChatContainerRef) {
								this.$refs.shoproChatContainerRef.scrollTop = this.$refs
									.shoproChatContainerRef.scrollHeight;
							}
						})
						this.shoproKefuShake = true
						break;
					}
					case 'message_list': { //接收到的消息列表
						//滚动条
						this.$nextTick(() => {
							if (this.page == 1) {
								this.$refs.shoproChatContainerRef.scrollTop = this.$refs
									.shoproChatContainerRef.scrollHeight;
							} else {
								this.$refs.shoproChatContainerRef.scrollTop = this.$refs
									.shoproChatContainerRef.scrollHeight -
									this.scrollHeight;
							}

							//保存原来的滚动条
							this.scrollHeight = this.$refs.shoproChatContainerRef.scrollHeight;

							this.$refs.shoproChatContainerRef.removeEventListener("scroll", this
								.listmore, false);
							this.$refs.shoproChatContainerRef.addEventListener('scroll', this.listmore,
								false)
						})
						this.shoproKefuShake = false;

						break;
					}
				}


			},
			closeErrorTipVisible() {
				this.errorTipVisible = false
			},
			listmore() {
				const now = Date.now()
				if (now - this.lastLoadTime < 800) return

				const el = this.$refs.shoproChatContainerRef
				//去除 message_num == 0
				if (
					el.scrollTop <= 20 &&
					this.isMoreLists
				) {
					this.lastLoadTime = now
					this.page++;
					let ChatingData = {
						identify: 'customer_service',
						type: 'message_list',
						session_id: this.isChatingId,
						data: {
							page: this.page,
							per_page: this.per_page,
							last_id: this.last_id
						}
					}
					this.$kefuSocket.send(ChatingData);
					// this.$emit('addPage')
				}
			},
			//选择聊天
			selectChating(chatid, index, opt, row) {
				this.rightShowId = null;
				this.kefuAccessStatus = false;
				this.kefuAccessStatusSend = false;
				this.kefuAccessTip = '';
				this.nickname = row.nickname


				//避免重复请求
				if (chatid == this.isChatingId && opt) {
					return false;
				}


				this.isChatingId = chatid;
				// this.specificChatMessage = [];
				this.message_num = 10;
				this.scrollHeight = 0;


				//清除未读
				let CLEAR_READObj = {
					index: index,
					groupIndex: this.groupIndex
				}


				if (index != null) {
					let data = {
						session_id: chatid,
						identify: 'customer_service',
						type: 'receipt',
					}
					this.$kefuSocket.send(data)
					this.$store.commit('kefu/CLEAR_READ', CLEAR_READObj)
				}
				// this.$emit('clearRead', index)
				// this.buylist[this.liaoData[this.groupIndex].type][index].message_unread_num = 0;

				//将排队中的拿过来
				if (this.groupIndex == 1) {
					this.$store.commit('kefu/SPLICEBUYWAIT', index)
					// if (index) this.$emit('spliceBuyWait', index)
					// this.buylist.buyerWaitings.splice(index, 1);
					let data = {
						// session_id: chatid,
						identify: 'customer_service',
						type: 'access',
					}
					this.$kefuSocket.send(data)
					// this.$emit('send', JSON.stringify(data))
				} else {
					let ChatingData = {
						identify: 'customer_service',
						type: 'message_list',
						session_id: this.isChatingId,
						data: {
							page: this.page,
							per_page: this.per_page,
							// last_id: 第一页不用传，以后一直传 第一页的第一条的消息的 id
						}
					}
					this.$kefuSocket.send(ChatingData)
					// this.$emit('send', JSON.stringify(ChatingData))
					// this.websocket.send(JSON.stringify(ChatingData));

					// 监听这个dom的scroll事件
					if (this.$refs.shoproChatContainerRef) {
						this.$refs.shoproChatContainerRef.removeEventListener("scroll", this.listmore, false);
					}
				}
				if (this.groupIndex == 2) {
					if (row.status == 1) {
						if (!row.customer_service) {
							this.kefuAccessStatus = true;
							this.kefuAccessStatusSend = true;
							this.kefuAccessTip = '等待客服接入';
							return false
						}
						if (row.customer_service && row.customer_service.id != this.adminData.customer_service.id) {
							this.kefuAccessStatus = true;
							this.kefuAccessStatusSend = true;
							this.kefuAccessTip = '客服 ' + row.customer_service.name + ' 正在服务，暂时无法与之会话!';
							return false
						}
					}
				}
			},
			closeKefuAccessStatus() {
				this.kefuAccessStatus = false;
				this.kefuAccessTip = ''
			},
			deleteChating() {
				this.$emit('deleteChating', this.chatid)
			},
			// selectCommonWords(index) {
			// 	this.commonWordsvisible = false;
			// 	this.doSend('text', this.commonWordsList[index].content)
			// 	this.specificChatMessage.push(this.initSendData('text', this.commonWordsList[index].content));
			// },
			selectEmoji(emoji) {
				this.emojivisible = false
				const src = require('@/assets/emoji/' + emoji.file)
				const imgHtml = `<img class="emoji" style="height: 18px;margin-right:2px" src="${src}" />`
				this.insertAtCursor(imgHtml)
			},
			insertAtCursor(html) {
				const editor = this.$refs.editor
				if (!editor) return

				editor.focus()

				const sel = window.getSelection()
				if (!sel || sel.rangeCount === 0) return

				const range = sel.getRangeAt(0)
				range.deleteContents()

				const el = document.createElement('div')
				el.innerHTML = html

				const frag = document.createDocumentFragment()
				let node
				while ((node = el.firstChild)) {
					frag.appendChild(node)
				}
				range.insertNode(frag)
				range.collapse(false)
			},
			selectGoods() {
				// let that = this;
				// parent.Fast.api.open("shopro/goods/goods/select?multiple=false", "选择商品", {
				//     callback: function (data) {
				//         that.doSend('goods', {
				//             id: data.data.id,
				//             title: data.data.title,
				//             image: data.data.image,
				//             price: data.data.price,
				//             stock: data.data.stock
				//         })
				//         that.specificChatMessage.push(that.initSendData('goods', data.data));
				//     }
				// });
			},
			openGoods() {
				// Fast.api.open("shopro/goods/goods/edit/ids/" + id + "?id=" + id + "&type=edit", '查看商品');
			},
			openOrder() {
				// Fast.api.open('shopro/order/order/detail?id=' + id, '查看订单');
			},
			getEditorHtml() {
				let html = this.$refs.editor.innerHTML || ''

				// 统一 div → br
				html = html
					.replace(/<div><br><\/div>/gi, '<br>')
					.replace(/<div>/gi, '<br>')
					.replace(/<\/div>/gi, '')

				// 去掉多余换行
				html = html.replace(/(<br>\s*)+$/g, '')

				return html.trim()
			},
			successMessage(event) {
				if (event) {
					//enter
					if (event.key == 'Enter' && event.ctrlKey) {
						event.preventDefault();
						event.cancelBubble = true;
						let html = this.$refs.editor.innerHTML;
						// var reg = new RegExp('<div><br></div>', "g")
						// html = html.replace(reg, '')
						if (html) {
							this.doSend('text', html)
							//暂时注释
							// this.specificChatMessage.push(this.initSendData('text', html));
						} else {
							this.$notify({
								title: '警告',
								message: '消息不能为空',
								type: 'warning'
							});
							return false;
						}
					} else if (event.key === 'Enter' && !event.ctrlKey) {
						event.preventDefault()
						const send = this.$refs.editor
						if (!send) return
						// 等价于 $('.shopro-send-pre').html(html + "<div><br/></div>")
						send.innerHTML += '<div><br></div>'

						// 光标移动到末尾（现代浏览器）
						send.focus()

						if (window.getSelection) {
							const selection = window.getSelection()
							const range = document.createRange()
							range.selectNodeContents(send)
							range.collapse(false)
							selection.removeAllRanges()
							selection.addRange(range)
						}
						this.msgInput = send.innerHTML
					}
				} else {
					//发送按钮
					if (this.$refs.editor.innerHTML) {
						this.doSend('text', this.getEditorHtml())
						//暂时注释
						// this.specificChatMessage.push(this.initSendData('text', this.getEditorHtml()));
					} else {
						this.$notify({
							title: '警告',
							message: '消息不能为空',
							type: 'warning'
						});
						return false;
					}
				}
			},
			handleClose() {
				this.dialogVisible = false;
				this.shoproKefuShake = false;
				this.kefuButtonvisible = false;
				this.rightShowId = null;
			},
			openDialog() {
				if (!this.isClick) {
					this.dialogVisible = true;
					this.kefuButtonvisible = false;
				}
			},
			// addfile(event) {
			//   let that = this;
			//   let formData = new FormData();
			//   formData.append("file", that.$refs.inputFileRef.files[0]);
			//   $.ajax({
			//     url: window.location.origin + "/addons/shopro/index/upload",
			//     type: 'post',
			//     data: formData,
			//     contentType: false,
			//     processData: false,
			//     success: function(res) {
			//       that.doSend('image', res.data.url)
			//       that.specificChatMessage.push(that.initSendData('image', res.data.url))
			//     },
			//     error: function(e) {
			//       layer.msg('文件上传失败');
			//     },
			//     complete: function() {
			//       that.$refs.inputFileRef.value = ""
			//     }
			//   })
			// },
			addfile(event) {
				// 防止重复提交（不影响原逻辑）
				if (this.uploading) return
				this.uploading = true

				const input = event.target
				const file = input.files?.[0]
				if (!file) return;
				const formData = new FormData()
				formData.append('file', file)

				fetch('https://michata.us.cc/api/common/upload', {
						method: 'POST',
						body: formData
					})
					.then(res => {
						if (!res.ok) {
							throw new Error('网络错误')
						}
						return res.json()
					})
					.then(res => {
						// ⭐ 保留你的原处理逻辑
						const url = res && res.data && res.data.fullurl
						if (!url) {
							throw new Error('返回数据异常')
						}

						this.doSend('image', url)
						//暂时注释
						// this.specificChatMessage.push(
						// 	this.initSendData('image', url)
						// )
					})
					.catch(() => {
						this.$notify({
							title: '错误',
							message: '图片上传失败',
							type: 'error'
						})
					})
					.finally(() => {
						this.uploading = false
					})
			},

			voicePlay() {
				new Audio('/assets/addons/shopro/audio/notice.wav').play();
			},
			//发送消息的数据组装
			doSend(type, message) {
				let submessage = message

				if (type === 'text') {
					// 匹配 emoji img
					const imgReg = /<img\s+class=["']emoji["'][^>]*>/gi
					const imgList = submessage.match(imgReg)
					if (imgList) {
						imgList.forEach(item => {
							// 提取 src
							const srcMatch = item.match(/src=["']([^"']+)["']/i)
							if (!srcMatch) return

							const path = srcMatch[1]

							// 🚫 跳过 base64
							if (path.startsWith('data:image')) return

							const fileWithHash = path.split('/').pop()

							// ⭐ 去掉 webpack / vite hash
							const cleanFile = fileWithHash.replace(/\.[a-zA-Z0-9]+(?=\.)/, '')
							console.log('send', cleanFile)
							// 查 emoji
							const emojiItem = this.selEmjioFile('file', cleanFile) || {
								name: '[常用语]'
							}

							submessage = submessage.replace(item, emojiItem.name)
						})
					}
				}

				let data = {
					session_id: this.isChatingId,
					identify: 'customer_service',
					type: 'message',
					message: {
						message_type: type,
						message: submessage,

						identify: {
							avatar: 'https://michata.us.cc/assets/img/avatar.png'
						},
						session_id: this.isChatingId,
						sender_identify: 'customer_service',
						createtime: Math.floor(Date.now() / 1000)
					},
				}
				this.$store.commit('kefu/ADD_MESSAGE', data.message)
				this.$store.commit('kefu/UPDATE_LAST_MESSAGE', {
					session_id: data.session_id,
					message: data.message,
					dataType: this.liaoStatus,
				})
				this.scrollBy('message')
				this.$kefuSocket.send(data)
				this.$refs.editor.innerHTML = ''
				// this.resetList()
				// this.$emit('send', JSON.stringify(data))
			},

			//重置列表
			resetList() {
				// this.$store.commit('kefu/SET_MESSAGE_LIST', [])
				this.page = 1
				let ChatingData = {
					identify: 'customer_service',
					type: 'message_list',
					session_id: this.isChatingId,
					data: {
						page: this.page,
						per_page: this.per_page,
						// last_id: 第一页不用传，以后一直传 第一页的第一条的消息的 id
					}
				}
				this.$kefuSocket.send(ChatingData)
				this.$refs.editor.innerHTML = ''
			},

			//发送之前处理数据
			initSendData(type, message) {
				this.$refs.editor.innerHTML = ''
				return {
					message: message,
					message_type: type,
					sender_identify: "customer_service",
					identify: this.adminData.customer_service
				}
			},
			timeFilter(datetime) {
				let timeday = ''
				// let timestamp = Date.parse(new Date())
				let datestamp = new Date(datetime)
				// if (timestamp - datetime < 86400) {
				//     var hour = ("0" + datestamp.getHours()).slice(-2),
				//         minute = ("0" + datestamp.getMinutes()).slice(-2);
				//     timeday = hour + ":" + minute
				// }else if (timestamp - datetime < 172800 && timestamp - datetime > 86400) {
				//     timeday = '昨天'
				// } else {
				timeday = datestamp.getFullYear() + '/' + (Number(datestamp.getMonth()) + 1) + '/' + datestamp.getDate() +
					' ' +
					("0" + datestamp.getHours()).slice(-2) + ':' + ("0" + datestamp.getMinutes()).slice(-2)
				// }
				return timeday;
			},

			// 表情地址
			selEmjioFile(type, value) {
				for (let index in this.emoji_list) {
					if (this.emoji_list[index][type] === value) {
						return this.emoji_list[index];
					}
				}
				return false;
			},
			// 替换表情
			replaceEmjio(data) {
				if (!data) return data

				let newData = data
				const reg = /\[(.+?)\]/g
				const zhEmojiName = newData.match(reg)

				if (zhEmojiName) {
					zhEmojiName.forEach(item => {
						const emojiItem = this.selEmjioFile('name', item);
						if (emojiItem && emojiItem.file) {
							const realSrc = require('@/assets/emoji/' + emojiItem.file);
							newData = newData.replace(
								item,
								`<img class="emoji" style="height:20px; width:20px; vertical-align:middle; margin:0 2px" src="${realSrc}" />`
							);
						}
					});
				}

				return newData
			}
		},
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-tabs__item:hover {
		color: #2e4fed;
	}

	::v-deep .el-tabs__item.is-active {
		color: #2e4fed;
	}

	::v-deep .el-tabs__active-bar {
		background-color: #2e4fed;
	}

	::v-deep .el-image__error,
	.el-image__inner,
	.el-image__placeholder {
		max-height: 130px;
	}

	.page {
		display: flex;
		flex-wrap: nowrap;
		/* padding: 20px 30px; */
		/* background-color: #f7f7f7; */
		height: calc(100vh - 100px);
	}

	.box-card {
		height: 100vh;
		width: 200px;
	}

	.text {
		font-size: 14px;
	}

	.item {
		margin-bottom: 18px;
	}

	.center {
		/* height: 800px; */
		width: 380px;
		border: 1px solid #e7e7e7;
		padding: 20px 10px;
		/* border-radius: 10px; */
		background-color: white;
	}

	.bottomPage {
		margin-top: 10px;

		.no-border-tabs>.el-tabs__header {
			border-bottom: none !important;
		}

		.chatCoList {
			.chatCoItem {
				border: 1px solid #828282;
			}
		}
	}

	.rightPage {
		border: 1px solid #e7e7e7;
		padding: 10px 10px;
		/* border-radius: 10px; */
		background-color: white;
		/* margin-left: 20px; */
		width: 100%;
	}

	/* 左侧聊天列表 */
	.chater-list-wrapper {
		height: 670px;
		overflow-y: auto;
	}

	.chater-list-wrapper::-webkit-scrollbar {
		width: 6px;
		background: #F4F4F4;
	}

	.chater-list-wrapper::-webkit-scrollbar-thumb {
		width: 6px;
		height: 10px;
		background: rgb(212, 212, 212);
		border-radius: 3px;
	}

	.topButton {
		display: flex;
		height: 35px;
		justify-content: space-between;
		border-bottom: 1px solid #e7e7e7;
	}

	.Name {
		font-size: 15px;
		font-weight: bold;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.closeChat {}

	/* .el-tab-pane{
    height: 100%;
    overflow-y: auto;
  } */

	.chater-header {
		display: flex;
		width: 300px;
		height: 38px;
		border-bottom: 1px solid #F4F4F4;
	}

	.chater-header-item {
		width: 100px;
		height: 38px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		font-size: 12px;
	}

	.ellipsis-item {
		font-size: 14px;
	}

	.display-flex {
		display: flex;
	}

	.chater-header-item-active {
		width: 84px;
		height: 26px;
		background: rgba(157, 96, 255, 0.2);
		border-radius: 18px;
		line-height: 26px;
		text-align: center;
		font-size: 12px;
		color: #7438D5;
	}

	.chater-header-container {
		flex: 1;
		overflow: auto;
		background: #F9F9F9;
	}



	.chater-header-list {
		padding: 8px 5px 8px 0px;
		border-bottom: 1px solid #F4F4F4;
		cursor: pointer;
		background: #fff;
		font-size: 12px;
	}

	.chater-header-list:hover {
		background: #d5ddfb;
	}

	.chater-el-icon-close {
		font-size: 10px;
		width: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.chater-el-icon-close i {
		display: none;
	}

	.leftTime {
		display: block;
		color: #999;
		font-size: 10px;
	}

	.chater-header-list:hover .leftTime {
		display: none;
	}

	.chater-header-list:hover .chater-el-icon-close i {
		display: block;
	}

	.chater-header-list-active,
	.chater-header-list-offline-active {
		background: #d5ddfb;
	}

	.chater-header-list-image {
		width: 35px;
		height: 35px;
		background: #C4C4C4;
		border: 1px solid #E6E6E6;
		margin-right: 5px;
		border-radius: 20px;
	}

	.chater-header-list-image img {
		width: 100%;
		height: 100%;
		border-radius: 20px;
	}

	.chater-header-list-message {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.chater-header-list-message-1 {
		display: flex;
		justify-content: space-between;
		line-height: 14px;
		margin-bottom: 6px
	}

	.chater-header-list-message-2 {
		line-height: 12px;
		font-size: 12px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		color: #999;
	}

	.line-status-online {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: aquamarine;
	}

	.offline-status {
		width: 5px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-radius: 50%;
		margin-right: 3px;
	}

	.line-status-offline {
		width: 5px;
		height: 5px;
		border-radius: 50%;
		background-color: #ee5959;
	}

	.specific-createtime {
		color: #999;
		text-align: center;
		font-size: 12px;
	}

	.chater-right {
		flex: 1;
		position: relative;
	}

	.message-dot {
		padding: 3px 5px;
		border-radius: 10px;
		text-align: center;
		background: #F15847;
		color: #fff;
	}

	.kefu-access-status {
		position: absolute;
		top: 20px;
		left: 16px;
		width: 565px;
		height: 42px;
		background: #FFFCF7;
		box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
		border-radius: 4px;
		padding: 0 16px;
		font-size: 14px;
		color: #F0AF41;
		display: flex;
		align-items: center;
		justify-content: space-between;
		z-index: 100;
	}

	.kefu-access-status-left i {
		margin-right: 8px;
	}

	.shopro-chat-container {
		height: 640px;
		padding: 20px;
		overflow: auto;
	}

	.shopro-chat-container-item {
		display: flex;
		margin-bottom: 22px;
	}

	.shopro-chat-container-item-system {
		width: 100%;
	}

	.shopro-chat-container-item-image {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		border-radius: 19px;
		margin-right: 14px
	}

	.shopro-chat-container-item-image-1 {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		border-radius: 19px;
		margin-left: 14px;
		
		::v-deep .el-image__inner {
			border-radius: 50%;
		}
	}

	.shopro-chat-container-item-message {
		background: #F6F6F6;
		border-radius: 6px 6px 6px 0px;
		max-width: 432px;
	}

	.shopro-chat-container-item-message-1 {
		max-width: 432px;
		border-radius: 20px 20px 0px 20px;
		color: #444;
		background: #e0f4f9;
		max-height: 150px;
	}

	.shopro-chat-container-item-message-text {
		padding: 10px;
		line-height: 18px;
	}

	.shopro-chat-container-item-message-text img {
		width: 100%;
	}

	.shopro-send-container {
		width: 100%;
		height: 120px;
		padding: 0 24px 0 16px;
		border-top: 1px solid #e6e6e6;
	}

	.shopro-send-tip-container {
		height: 33px;
		display: flex;
		align-items: center;
	}

	.shopro-send-tip-item {
		width: 22px;
		height: 22px;
		margin-right: 12px;
		cursor: pointer;
	}

	.shopro-send-textarea {
		height: 44px;
		overflow: auto;
	}

	.shopro-send-textarea::-webkit-scrollbar {
		width: 6px;
	}

	.shopro-send-textarea::-webkit-scrollbar-thumb {
		width: 6px;
		background: #ccc;
		height: 20px;
		border-radius: 3px;
	}

	.shopro-send-textarea textarea {
		height: 44px;
		width: 554px !important;
		border: none;
		margin: 0px;
	}

	.shopro-send-textarea textarea:focus {
		border: none !important;
	}

	.shopro-send-button-container {
		padding: 12px 0;
		height: 64px
	}

	.shopro-send-button {
		width: 78px;
		height: 30px;
		line-height: 30px;
		text-align: center;
		font-size: 13px;
		color: #fff;
		background: #1890ff;
		border-radius: 4px;
		float: right;
		cursor: pointer;
	}


	#inputFile {
		display: none;
	}

	.shopro-chat-goods-item {
		min-width: 240px;
		height: 60px;
		/* background: #FFFFFF; */
		/* border: 1px solid #E6E6E6; */
		border-radius: 4px;
		padding: 8px;
		display: flex;
		align-items: center;
	}

	.shopro-chat-goods-image {
		width: 44px;
		height: 44px;
		border: 1px solid #E6E6E6;
		border-radius: 3px;
		margin-right: 10px;
	}

	.shopro-chat-goods-image .el-image,
	.shopro-chat-image {
		position: relative;
		border-radius: 3px !important;
		max-width: 300px;
		
		
	}
	

	.shopro-chat-goods-message {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex: 1;
		height: 100%;
	}

	.shopro-chat-goods-bodys {
		justify-content: space-between;
		height: 20px;
	}

	.customer-service {
		color: #fff;
		justify-content: flex-end;
	}

	.customer-user {
		color: #444;
		justify-content: flex-start;
	}

	.customer-system {
		justify-content: center;
	}

	.shopro-chat-system {
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		border-radius: 10px;
		background: #f9f9f9;
	}

	.shopro-chat-emoji-container {
		display: flex;
		flex-wrap: wrap;
		height: 150px;
		overflow: auto;
		padding: 10px 10px 5px;
	}

	.shopro-chat-emoji-image {
		width: 24px;
		height: 24px;
		cursor: pointer;
		/* border: 1px solid #E6E6E6; */
		border-radius: 3px;
		margin-right: 10px;
		margin-bottom: 5px;
	}

	.shopro-chat-container-tip {
		font-size: 16px;
		color: #999999;
		margin-top: 30px;
		text-align: center;
	}

	.shopro-chat-emoji-image:nth-of-type(6n) {
		/* margin-right: 0px; */
	}

	.shopro-send-pre,
	.shopro-send-pre:focus,
	.shopro-send-pre:default {
		border: none !important;
		outline: none;
		background: none;
		height: 44px;
		padding: 0;
	}

	/* 👇 没内容时显示 placeholder */
	.shopro-send-pre:empty::before {
		content: attr(data-placeholder);
		color: #aaa;
		pointer-events: none;
	}

	/* 兼容有 <br> 的情况 */
	.shopro-send-pre:empty:focus::before {
		content: '';
	}

	.shopro-send-textarea::-webkit-scrollbar {
		width: 6px;
	}

	.shopro-send-textarea::-webkit-scrollbar-thumb {
		width: 6px;
		background: #ccc;
		height: 10px;
		border-radius: 3px;
	}

	.scrollbar-containering::-webkit-scrollbar {
		width: 6px;
		background: #F4F4F4;
	}

	.scrollbar-containering::-webkit-scrollbar-thumb {
		width: 6px;
		background: #e6e6e6;
		height: 10px;
		border-radius: 3px;
	}

	.el-popover {
		padding: 0;
	}

	.el-popover-common-words {
		max-height: 150px;
		overflow-y: auto;
		font-size: 12px;
	}

	.emoji {
		width: 20px !important;
		height: 20px !important;
		margin: 0 2px;
	}

	.no-more-data {
		text-align: center;
		font-size: 14px;
		color: #999;
	}
</style>